import React, { Component } from "react";
import { Helmet } from "react-helmet";

import TicketSelectField from "./TicketSelectField";
import SelectBeneficiary from "../components/SelectBeneficiary";
import CheckoutError from "../components/CheckoutError";
import Button from "./Button";
import { AppContext } from "../utils/context";
import { formatCurrency } from "../utils/constants";

class CheckoutTickets extends Component {
  constructor(props) {
    super(props);

    let beneficiaries = [];

    const { context, cart } = props;

    context.event.beneficiaries.forEach(beneficiary => {
      if (beneficiary.logo_url) {
        beneficiaries.push({
          label: <div><img style={{ position: 'relative', borderRadius: '50%', verticalAlign: 'middle', width: '35px', height: '35px' }} src={beneficiary.logo_url} />{beneficiary.name}</div>,
          value: beneficiary.id
        });
      }
      else {
        beneficiaries.push({
          label: beneficiary.name,
          value: beneficiary.id
        });
      }
    })

    this.state = {
      beneficiaries: beneficiaries,
      addonCount: Object.keys(context?.event?.addons)?.length ?? 0,
      addonEvents: context?.event?.addons ?? null,
      currentEvent: context?.event
    };

    if (+context.event.shopify_enabled === 1) {
      window.location.href = "/";
    }

    // Redirect user to home page if cart's undefined
    if (!cart && window.location.pathname != '/free-tickets/select-tickets') {
      window.location.href = "/";
    }
  }

  render() {
  const {
    context,
    cart,
    handleCart,
    handleBeneficiary,
    validateCart,
    validateCartTickets,
    valid,
    goToPrevious,
    tickets_error,
    freeTicket,
    displayAddonPPsProp,
    beneficiaryId,
    errorReturnHome,
    purchaseLimitExceeded,
    maxPurchaseLimit
  } = this.props;

    const { localLanguage, config } = this.context;
    const { beneficiaries, addonCount, addonEvents, currentEvent } = this.state;

    const eventEndedAlert = {
        code: 3,
        message: localLanguage.general_event_end_return_home,
        action: "default"
    }
    const priceChangeAlert = {
        code: 4,
        message: localLanguage.general_pricing_changed_reload,
        action: "reload"
    }

    let productForStringMN = localLanguage.general_num_tickets_for;
    let productForStringSN = localLanguage.general_num_chances_for;

    if (!context.event.is_active || context.event.web_sales_paused) { // alert user that event ended
        return (<CheckoutError
            error={eventEndedAlert}
            errorReturnHome={errorReturnHome}
        />);
    }

    let eventAddonsCount = Object.keys(context?.event?.addons)?.length ?? 0;
    if (context.config.option_allow_addons && addonCount !== eventAddonsCount) { // alert user of addon event changes
        return (<CheckoutError
            error={priceChangeAlert}
            errorReturnHome={errorReturnHome}
        />);
    }

    let prevEventAddons = context?.event?.addons ?? null;
    if (context.config.option_allow_addons && prevEventAddons && addonCount) { // alert user of addon dynamic pricing changes
        const addonPricingChange = addonEvents.every((addon, key) => {
            let prevAddonPrices = context?.event?.addons[key]?.prices;
            if (prevAddonPrices) return (JSON.stringify(prevAddonPrices) !== JSON.stringify(addon.prices));
        });
        if (addonPricingChange)
            return (<CheckoutError
                error={priceChangeAlert}
                errorReturnHome={errorReturnHome}
            />);
    }

    let prevEvent = context?.event;
    if (prevEvent && currentEvent && JSON.stringify(prevEvent.prices) !== JSON.stringify(currentEvent.prices)) { // alert user of dynamic pricing changes
        return (<CheckoutError
            error={priceChangeAlert}
            errorReturnHome={errorReturnHome}
        />);
    }

    let displayAddonPPs = displayAddonPPsProp;

    return (
      <form className="w-full md:w-2/3">
        <Helmet>
          {context.settings.scripts_select_tickets && <script>{context.settings.scripts_select_tickets}</script>}
        </Helmet>
        <h2 className="mb-6">
            {freeTicket && freeTicket > 0 ?
            localLanguage.general_claim_free_ticket :
            localLanguage.general_select_tickets}
        </h2>
        {freeTicket > 0 && context.event.title !== "" && <h4>{localLanguage.general_event}: {context.event.title}</h4>}
        <div className="flex flex-wrap mb-6">
          {cart &&
            cart.map((c, k) => (
                <TicketSelectField
                    key={k}
                    id={`cart-${k}`}
                    label={`${(c.numberModel == 'multi_number' ? productForStringMN : productForStringSN).replace('{c.tickets}', c.tickets).replace('${c.cost}', formatCurrency(c.cost))}`}
                    value={c.qty}
                    disabled={c.disabled}
                    eventName={c.eventName}
                    gameType={c.gameType}
                    gameId={c.gameId}
                    isSTP={c.isSTP}
                    prizeLabel={c.prizeLabel}
                    prize={c.prize}
                    jackpotLabel={c.jackpotLabel}
                    jackpot={c.jackpot}
                    addonPrizeLabel={c.addonPrizeLabel}
                    addonPrize={c.addonPrize}
                    addonJackpotLabel={c.addonJackpotLabel}
                    addonJackpot={c.addonJackpot}
                    addonGameId={c.addonGameId}
                    isFirstPricePoint={c.isFirstPricePoint}
                    isAddonPP={c.isAddonPP}
                    isFirstEverAddonPP={c.isFirstEverAddonPP}
                    hidden={c.hidden}
                    mainEventTitle={context.event.title}
                    displayAddonPPs={displayAddonPPs}
                    handleChange={handleCart}
                />
            ))}

          {/* Beneficiary Selection Section */}
          {cart && context.event.beneficiaryenabled === 1 && (
            <div className="w-full px-3 mb-4 mt-4">
              <div className="border rounded-lg p-6 shadow-sm">
                <SelectBeneficiary
                  container="w-full"
                  id="beneficiaryId"
                  name="context.event.beneficiary"
                  options={beneficiaries}
                  required={+context.settings.mandatory_beneficiary === 1}
                  handleBeneficiary={handleBeneficiary}
                  label={localLanguage.beneficiary_label}
                  placeholder={localLanguage.beneficiary_placeholder}
                  beneficiaryId={beneficiaryId}
                />
              </div>
            </div>
          )}

          {/* Processing Fees Section */}
          {cart && context.settings.enable_customer_processing_fees === "1" && context.event.expense_cc_customer_enabled && (
            <div className="w-full px-3 mb-8 mt-4">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 shadow-sm">
                <label className="flex items-start cursor-pointer group">
                  <input
                    type="checkbox"
                    id="coverProcessingFees"
                    name="coverProcessingFees"
                    checked={this.props.coverProcessingFees || false}
                    onChange={this.props.toggleProcessingFees}
                    className="mt-1 mr-4 form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500 focus:ring-2 transition-colors"
                  />
                  <div className="flex-1">
                    <div className="flex items-center flex-wrap">
                      <span className="text-base font-medium text-gray-900 mr-2">
                        {localLanguage.cover_processing_fees_label}
                      </span>
                      <span className="text-blue-600 font-semibold bg-blue-100 px-2 py-1 rounded text-sm min-w-[60px] text-center">
                        {this.props.processingFees > 0 && formatCurrency(this.props.processingFees, 2)}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                      {localLanguage.cover_processing_fees_description}
                    </p>
                  </div>
                </label>
              </div>
            </div>
          )}
          {tickets_error && (
            <div className="w-full flex justify-center mt-6">
              <div className="bg-white border border-danger text-danger px-4 py-3 rounded relative" role="alert">
                {valid.cartTotal && (<i className="block md:inline font-bold">{valid.cartTotal}</i>)}
                {valid["beneficiaryId"] && !valid.cartTotal && (<i className="block md:inline font-bold">{valid["beneficiaryId"]}</i>)}
              </div>
            </div>
          )}
          {purchaseLimitExceeded && (
            <div className="w-full flex justify-center mt-6">
              <div className="bg-white border border-danger text-danger px-4 py-3 rounded relative" role="alert">
                <i className="block md:inline font-bold">
                  {localLanguage.max_purchase_limit_warning.replace('${maxPurchaseLimit}', formatCurrency(maxPurchaseLimit))}
                </i>
              </div>
            </div>
          )}
        </div>
        <div className="w-full flex flex-wrap mb-6 justify-center justify-between">
          {!freeTicket &&
            <Button
              onClick={goToPrevious}
              color="secondary"
              textColor="primary"
              content={localLanguage.general_back}
              rounded
            />
          }
          {context.event.game.id === 3 ?
            <Button color="accent" textColor="primary" onClick={validateCart} content={localLanguage.general_continue} continueButton="true" disabled={purchaseLimitExceeded} rounded />
            :
            <Button color="accent" textColor="primary" onClick={validateCartTickets} content={localLanguage.general_continue} continueButton="true" disabled={purchaseLimitExceeded} rounded />
          }
        </div>
      </form>
    );
  }
}
CheckoutTickets.contextType = AppContext;

export default CheckoutTickets;
